export class SwaggerUrl {
  public id: string;
  public url: string;
  public name: string;
  public apiUrl: string;
  public useTls: boolean;
  public tlsUseXRoadComponent: boolean;
  public tlsUseUxp: boolean;
  public tlsUxpClient: string;
  public tlsUxpService: string;
  public tlsType: string;
  public tlsKeystorePath: string;
  public tlsKeystoreAlias: string;
  public tlsUsingPassword: boolean;
  public tlsKeyPassword: string;
  public tlsUsingKeyPassword: boolean;
  public tlsInsecure: boolean;
  public wsdlGenerateCollectionItems: boolean;
  public wsdlItemsInCollection: number;
}
